/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-11 14:57:33
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-11-06 17:29:45
 * @FilePath: /qd-c4-yunjing-web/src/config/micro-app.ts
 * @Description: 这是默认设置
 */
import { pinia } from '@/store/index';
import { useAppStore } from '@/store/app';
import { useOrgStore } from '@/store/org';
import { useUserStore } from '@/store/user';
import { entryMap } from '@/utils/constants';

type MicroAppsItem = {
  name: string;
  entry: string;
  activeRule: string;
  container: string;
  useThreeModel: boolean;
  props?: Record<string, any>;
};

// 微应用列表
const microApps: MicroAppsItem[] = [
  {
    name: 'ems',
    entry: entryMap.ems,
    activeRule: '/ems',
    container: '#subapp-viewport',
    useThreeModel: true,
  },
  {
    name: 'ibms',
    entry: entryMap.ibms,
    activeRule: '/ibms',
    container: '#subapp-viewport',
    useThreeModel: true,
  },
  {
    name: 'dmp',
    entry: entryMap.dmp,
    activeRule: '/dmp',
    container: '#subapp-viewport',
    useThreeModel: true,
  },
  {
    name: 'insight',
    entry: entryMap.insight,
    activeRule: '/insight',
    container: '#subapp-viewport',
    useThreeModel: true,
  }
];

const apps = microApps.map((item: MicroAppsItem) => ({
  ...item,
  props: {
    // 主应用向子应用下发基础参数
    router: true,
    routerBase: item.activeRule,
    appInfo: item,
    _mainAppStore: useAppStore(pinia),
    _mainOrgStore: useOrgStore(pinia),
    _mainUserStore: useUserStore(pinia),
    modeType: useOrgStore(pinia).currentOrgInfo.source,
  },
}));

export default apps;
